export function milestonePartiesEqual(backendParties, frontEndParties) {
  return backendParties?.every((party) => {
    const frontEndParty = frontEndParties?.find(
      (frontParty) => frontParty?.phoneNumber === party?.phoneNumber
    );

    return (
      party?.amount === frontEndParty?.amount &&
      party?.phoneNumber === frontEndParty?.phoneNumber
      // TODO: The name field has no usage for us because we find the namee by number
      // party?.name === frontEndParty?.name
    );
  });
}
